import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";


export class JanelaAtualizacaoInformacoes extends BaseEntity{
  public dataBase: Date;
  
  public dataAbertura: Date;

	public dataFechamento: Date;

  public dataInicioListagemOperacoes: Date;
  
  public dataFimListagemOperacoes: Date;

  public tipoJanela: string;

  public modalidadeGarantia: string;

  public nomeUsuarioInsercao:string;

  public processamentoHabilitado: string;
	
	public dataUltimaExecucao: Date;
	
	public ultimaExecucaoRealizadaComSucesso: string;

}

export const TIPOS_JANELA= [
    {
      codigo: '1',
      label: 'Classificação de Risco'
    },
    {
      codigo: '2',
      label: 'Posição da Carteira em Recuperação de Crédito'
    }
  ];

